import { Options, Vue } from 'vue-class-component'
import SimpleCalendar from '@/components/Frontend/SimpleCalendar/index.vue'
import { Posts } from '@/services/PostsDataService'
import SysPost, { SysPostCategory } from '@/types/SysPost'

interface SocialLink {
  name: string;
  icon: string;
  link: string;
  alt: string;
}

@Options({
  components: {
    SimpleCalendar
  }
})
export default class LeftSideBar extends Vue {
  private indlaegs: SysPost[] = []
  private indlaegkategoris: SysPostCategory[] = []
  error: any = null
  postCategoryTitleOptions: string[] = []
  filterPostCategoryStringOptions: { name: string; id: string }[] = []

  public async retrievePostCategories (): Promise<void> {
    await Posts.PostCategoriesDataService.getAll()
      .then((response) => {
        this.indlaegkategoris = response.data
      })
      .catch((err) => {
        this.error = err
      })
  }

  goToCategory (categoryName: string): void {
    console.log(categoryName)
    const formattedName = encodeURIComponent(categoryName)
    this.$router.push({ name: 'category', params: { categoryType: formattedName } })
  }

  async mounted () : Promise<void> {
    this.retrievePostCategories()
  }
}

declare module 'vue' {
  interface ComponentCustomProperties {
    followUs: SocialLink[]
  }
}
